var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMentalHealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "appointment-types__type-svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.5,
    height: 39.34,
    viewBox: "0 0 42.5 39.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    transform: "translate(-333.75 -435.363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M21.359,32.307v0a9.182,9.182,0,0,1,6.857,2.285,10.669,10.669,0,0,1,3.428,7.432l2.2,4.321a.448.448,0,0,1,.023.054,1.215,1.215,0,0,1-.085.986,1.172,1.172,0,0,1-.76.576l-1.644.378-.46,5.211a1.175,1.175,0,0,1-1.161,1.068l-.047,0-3.427-.378V57.19a.431.431,0,0,1-.861,0V53.753a.431.431,0,0,1,.478-.428l3.876.427a.316.316,0,0,0,.285-.288l.487-5.517a.43.43,0,0,1,.333-.382l1.949-.448a.308.308,0,0,0,.2-.154.354.354,0,0,0,.032-.264l-2.17-4.27a.43.43,0,0,1-.1-.255,9.821,9.821,0,0,0-3.146-6.942,8.318,8.318,0,0,0-6.22-2.07v0l-.022,0a.428.428,0,0,1-.042-.855Z",
    transform: "translate(313.029 416.832)",
    fill: "#9d9c9c",
    stroke: "#9d9c9c",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M187.339,32.307v0a9.182,9.182,0,0,0-6.857,2.285,10.669,10.669,0,0,0-3.428,7.432l-2.2,4.321a.448.448,0,0,0-.023.054,1.215,1.215,0,0,0,.085.986,1.172,1.172,0,0,0,.76.576l1.644.378.46,5.211a1.175,1.175,0,0,0,1.161,1.068l.047,0,3.427-.378V57.19a.431.431,0,0,0,.861,0V53.753a.431.431,0,0,0-.478-.428l-3.876.427a.316.316,0,0,1-.285-.288l-.487-5.517a.43.43,0,0,0-.333-.382l-1.949-.448a.308.308,0,0,1-.2-.154.354.354,0,0,1-.032-.264l2.17-4.27a.43.43,0,0,0,.1-.255,9.821,9.821,0,0,1,3.146-6.942,8.318,8.318,0,0,1,6.22-2.07v0l.023,0a.428.428,0,0,0,.042-.855Z",
    transform: "translate(188.274 416.832)",
    fill: "#9d9c9c",
    stroke: "#9d9c9c",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "appointment-types__type-svg-fill",
    id: "Path_239",
    "data-name": "Path 239",
    d: "M490.851,653.664l3.812-.758,3.835.758,3.045,2.591,1.912,4.238-.508,4.6-2.2,3.412s-3.691,2.018-3.788,2.032-4.346.147-4.346.147l-2.861-1.117-3.763.466,1.016-3.652S485.62,663.1,485.628,663s.436-2.949.363-3.132a21.319,21.319,0,0,1,1.488-3.852c.27-.332,2.485-2.107,2.485-2.107Z",
    transform: "translate(-138 -217)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(-68.311 156.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M424.83,279.063a9.518,9.518,0,0,0-8.253,14.261l-.706,2.634a1.274,1.274,0,0,0,.34,1.248,1.292,1.292,0,0,0,1.25.325l2.62-.7a9.52,9.52,0,0,0,13-3.5h0a9.518,9.518,0,0,0-3.5-13h0A9.525,9.525,0,0,0,424.83,279.063Zm0,17.845a8.319,8.319,0,0,1-4.347-1.22.6.6,0,0,0-.465-.068l-2.866.769h-.007a.1.1,0,0,1-.1-.027.09.09,0,0,1-.026-.094l.771-2.875a.6.6,0,0,0-.068-.465,8.329,8.329,0,0,1,2.756-11.451h0a8.327,8.327,0,0,1,11.45,2.754v0a8.328,8.328,0,0,1-2.755,11.451h0a8.34,8.34,0,0,1-4.348,1.224Z",
    transform: "translate(0)",
    fill: "#9d9c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M429.168,286.369H423.22a.595.595,0,0,0,0,1.189h5.948a.594.594,0,0,0,.594-.594v0A.594.594,0,0,0,429.168,286.369Z",
    transform: "translate(-1.364 -1.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M429.168,290.03H423.22a.595.595,0,0,0,0,1.189h5.948a.6.6,0,0,0,.595-.595h0a.594.594,0,0,0-.595-.595Z",
    transform: "translate(-1.364 -2.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M429.168,293.686H423.22a.595.595,0,0,0,0,1.189h5.948a.6.6,0,0,0,.595-.595h0a.594.594,0,0,0-.595-.595Z",
    transform: "translate(-1.364 -2.726)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentalHealth);
export default __webpack_public_path__ + "static/media/mental_health.db017fe3c3a3f6b5c8f4cd83dd981de8.svg";
export { ForwardRef as ReactComponent };